import React, { useEffect, useState } from "react";
import s from "./index.module.scss";
import classNames from "classnames";
import ModalWrapper from "../UI/ModalWrapper";
import { ReactComponent as CloseIcon } from "../../assets/icons/cross.svg";
import SimpleBar from "simplebar-react";
import Loader from "../UI/Loader";

interface IModalProps {
  isLoading?: boolean;
  headerTitle?: string | React.ReactNode;
  headerSubtitle?: string | React.ReactNode;
  isReversedTitles?: boolean;
  status?: boolean;
  editHandler?: () => void;
  blockHandler?: () => void;
  closeHandler: () => void;
  children: React.ReactNode;
  deleted?: boolean;
  disableEdit?: boolean;
}

interface ITitleProps {
  children: React.ReactNode;
}

type ModalCmp = React.FC<IModalProps> & {
  Title: React.FC<ITitleProps>;
};

const DetailModalWrapper: ModalCmp = ({
  isLoading,
  headerTitle,
  headerSubtitle,
  isReversedTitles = false,
  status,
  editHandler,
  blockHandler,
  closeHandler,
  children,
  deleted,
  disableEdit,
}) => {
  const [isAnimate, setIsAnimate] = useState<boolean>(false);

  const hasHeader = headerTitle && headerSubtitle && editHandler;

  const onClose = () => {
    setIsAnimate(true);
    setTimeout(() => {
      closeHandler();
    }, 300);
  };

  useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.code === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", listener);
    return () => document.removeEventListener("keydown", listener);
  }, []);

  return (
    <ModalWrapper closeHandler={onClose} isAnimate={isAnimate}>
      <div
        className={classNames(s.wrapper, {
          [s.animate]: isAnimate,
        })}
      >
        <div className={s.close} onClick={onClose}>
          <CloseIcon />
        </div>
        <SimpleBar
          style={{
            maxHeight: "calc(100vh - 88px)",
            overflowX: "hidden",
            padding: "0 60px 60px 0",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {hasHeader && (
                <div className={s.header}>
                  <div
                    className={classNames({
                      [s.headerReverse]: isReversedTitles,
                    })}
                  >
                    <h2 className={s.headerTitle}>{headerTitle}</h2>
                    <span className={s.headerSubtitle}>{headerSubtitle}</span>
                  </div>
                  <div className={s.headerActions}>
                    {!disableEdit && (
                      <div className={s.headerEdit} onClick={editHandler}>
                        Редагувати
                      </div>
                    )}
                    {!disableEdit && !deleted && !!blockHandler && (
                      <div
                        className={classNames(s.headerBlock, {
                          [s.active]: status,
                        })}
                        onClick={blockHandler}
                      >
                        {status ? "Заблокувати" : "Разблокувати"}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {children}
            </>
          )}
        </SimpleBar>
      </div>
    </ModalWrapper>
  );
};

const Title: React.FC<ITitleProps> = ({ children }) => {
  return <p className={s.blockTitle}>{children}</p>;
};

DetailModalWrapper.Title = Title;

export default DetailModalWrapper;
